import {TICK_DOMAIN} from '../../config/config';
import {suspendedConfirmation} from '../../redux/event/eventActions';

export const suspendedConfirmationLoader = async ({request}) => {
    const redirect = () => window.location.replace(TICK_DOMAIN);

    try {
        const url = new URL(request.url);
        const confirm = url.searchParams.get('confirm');

        if(!confirm) {
            // If no confirm parameter, redirect to home
            redirect();
            return {
                success: false,
            };
        }
        
        const response = await suspendedConfirmation(confirm);
        if(response?.status) {
            const language = response.order?.lang || 'en';
            return {
                success: true,
                confirm,
                status: response.status,
                order: response.order || null,
                language,
                preloadedData: {
                    hasConfirmation: true,
                    hasOrder: !!response.order,
                    hasLanguage: !!response.order?.lang
                }
            };
        } else {
            return {
                success: false,
                confirm,
                status: 'failed',
                error: 'Confirmation failed',
                preloadedData: {
                    hasConfirmation: false,
                    hasOrder: false
                }
            };
        }
    } catch (error) {
        console.warn('SuspendedConfirmation loader error:', error);
        return {
            success: false,
            error: error.message,
            preloadedData: {
                hasConfirmation: false,
                hasOrder: false
            }
        };
    }
};
